(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exports(
            require('./metric.js'),
            require('../collections/metrics.js').MetricDefinitions,
            require('lodash')
        );

    } else {

        RivalIQ.metric.data = exports(
            RivalIQ.metric,
            RivalIQ.collections.MetricDefinitions,
            window._
        );
    }

    function exports(metricFn, MetricDefinitions, _) {

        const exports = {
            rank: rank,
            fetch: fetch,
            rawValue: rawValue
        };

        // Fetch the metric and returns its data array
        function fetch(metric) {
            return new MetricDefinitions([metric]).fetch({})
                .then(function (metrics) {
                    return metrics.first().getValue({
                        format: false
                    });
                });
        }

        function sortData(data, order) {
            order = (order === 1 ? 'asc' : 'desc');
            data = _.orderBy(data, _.last, order);
            return _.reject(data, function (datum) {
                return _.isNull(_.last(datum));
            });
        }

        function rawValue(metric, data) {
            // this is to pull just a value out of a metric (like a value+currency object)
            let value = _.last(data);
            value = (_.isObject(value) ? value.value : value);

            const numericValue = Number(value);
            if (!isNaN(numericValue)) {
                value = numericValue;
            }

            return value;
        }

        /*
         * Fetches data and returns the leader and the value of the 1target`
         * The target is typically the focus company
         * NOTE currently only supports a single target dimension
         */
        function rank(metric, targetAttrs, order) {
            if (_.isArray(metric)) {
                const deferreds = _.map(metric, _.partial(rank, _, targetAttrs, order));
                return $.when.apply(null, deferreds);
            }

            // NOTE currently only supports a single target dimension
            const idx = 0;
            const targetDimension = metricFn.getFreeDimensions(metric)[idx];

            return exports.fetch(metric).then(function (data) {
                data = sortData(data, order);

                function buildDataEntry(datum, i) {
                    return {
                        rank: _.isNumber(i) ? i + 1 : null,
                        dimensionValue: _.get(datum, idx, null),
                        value: (_.isArray(datum) ? _.last(datum) : null)
                    };
                }

                let tIdx;
                data = _.map(data, function (datum, i) {
                    if (datum[idx] === targetAttrs[targetDimension]) {
                        tIdx = i;
                    }

                    return buildDataEntry(datum, i);
                });

                let target;
                if (_.isUndefined(tIdx)) {
                    target = buildDataEntry();
                } else {
                    target = data[tIdx];
                }

                let leader = data[0];
                if (!leader) {
                    leader = buildDataEntry();
                }

                return {
                    count: data.length,
                    leader: leader,
                    target: target,
                    data: data
                };
            });
        }

        return exports;
    }
})();
